export default __webpack_public_path__ + "static/media/img_publi5.5b7a3458.svg";